
const Modal = require('ui/Modal.js');

class Button {

    defaultOptions(){
        return {
            '$btn': null,

            'alreadyDownloadCookieName': 'OPUS_BROCHURE_ZOHOFORM_DOWNLOADED_ELEMENTS',
            'alreadySubmitedCookieName': 'OPUS_BROCHURE_ZOHOFORM_SUBMITED',
        };
    }

    constructor(options){
        this.settings = $.extend(this.defaultOptions(),options);

        //method/events
        this.onDownload = this.onDownload.bind(this);
        this.onClick = this.onClick.bind(this);

        //attributes
        this.$btn = this.settings.$btn;
        if(!this.$btn || this.$btn.length <= 0){
            console.error("Can't instanciate BrochureButton without $btn");
            return;
        }

        this.modal = null;
        this.file = this.$btn.data('file');
        this.target = this.$btn.data('target');

        this.modalShown = false;

        this.initialize();
    }

    getZohoFormUrl(){
        return this.$btn.data('zohoform-url');
    }

    initialize(){
        var self = this;
        this.$btn.on('click',this.onClick);
        this.$btn.on('download',this.onDownload);
    }

    closePreviousModalIfExist(){
        let $modal = $('#brochureZohoFormModal',window.top.document);
        if($modal.length > 0){
            $modal.modal('hide');
            $('body',window.top.document).removeClass('modal-open');
            $('.modal-backdrop',window.top.document).remove();
            $modal.remove();
        }
    }

    trigger(event){
        //console.log("trigger event ",event,this.$btn);
        this.$btn.trigger(event);
    }

    buildIFrameModal(){
        var self = this;

        this.modal = new Modal({
            'id': 'brochureZohoFormModal',
            'showFooter': false,
            'showHeader': true,
            'modalSize': 'lg',
            'modalClass': 'brochure-modal',
            'onClose': function(event){
                self.modalShown = false;
            },
            'onShown': function(event,modal){
                self.modalShown = true;
            }
        });

        let iframeId = 'brochureIframe-'+this.target;
        let height = Math.round(this.modal.getHeight() * 70 / 100);

        let $iframe = $('<iframe/>')
        .attr('id','brochureZohoForm')
        .addClass('brochure-iframe')
        .attr('src',this.getZohoFormUrl())
        .attr('width','100%')
        .attr('height',height)
        .css('width','100%')
        .css('height',height)
        .on('load',function(event){
            self.onIframeLoad(event);
        });

        this.modal.setBodyContent($iframe);
    }

    onIframeLoad(event){

    }

    getTarget(){
        return this.target;
    }

    isFormAlreadySubmited(){
        let cookieValue = window.getCookie(this.settings.alreadySubmitedCookieName);
        if(cookieValue && cookieValue == 1){
            return true;
        }
        return false;
    }

    onClick(event){
        event.preventDefault();
        event.stopPropagation();
        if(this.$btn.hasClass('submited')){
            return this.downloadFile();
        }
        if(this.isAlreadyDownloaded()){
            return this.downloadFile();
        }
        this.showForm();
    }

    onDownload(event){
        event.preventDefault();
        event.stopPropagation();

        if(this.isFormAlreadySubmited()){
            this.downloadFile();
        }else{
            this.showForm();
        }
    }

    showForm(){
        if(!this.modal){
            this.buildIFrameModal();
        }
        this.modal.show();
    }

    closeModal(){
        this.modal.hide();
    }

    downloadFile(){
        //console.log("process download");
        if(this.modalShown){
            this.closeModal();
        }
        //console.log("modal has been removed ?");
        let href = this.file;
        let filename = new URL(href).pathname.split('/').pop();
        let anchor = document.createElement('a');
        anchor.href = href;
        anchor.target = '_blank';
        //anchor.download = filename;
        document.body.appendChild(anchor);
        //console.log("simulate click on fake  btn",anchor);
        anchor.click();

        anchor.remove();

        this.rememberDownload();

        //console.log("force modal removal just in case");
        this.closePreviousModalIfExist();
    }


    getAlreadyDownloadedFiles(){

        let cookieValue = window.getCookie(this.settings.alreadyDownloadCookieName);
        if(cookieValue){
            return cookieValue.split(',');
        }
        return [];
    }

    isAlreadyDownloaded(){
        let alreadyDownloadedFiles = this.getAlreadyDownloadedFiles();
        //console.log("isAlreadyDownloaded ? ",this.getBaseName(),alreadyDownloadedFiles);
        return alreadyDownloadedFiles.includes(this.getBaseName());
    }

    rememberDownload(){
        if(this.isAlreadyDownloaded()){
            return this;
        }
        let alreadyDownloadedFiles = this.getAlreadyDownloadedFiles();
        //console.log("add file to remember",this.getBaseName(),alreadyDownloadedFiles);
        alreadyDownloadedFiles.push(this.getBaseName());
        window.setCookie(this.settings.alreadyDownloadCookieName,alreadyDownloadedFiles.join(','));
        return this;
    }

    getBaseName(){
        return window.getBasename(this.file);
    }
}

module.exports = Button;